import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { BarcodeStore } from './barcode.store';
import { Barcode } from './barcode.model';

@Injectable({ providedIn: 'root' })
export class BarcodeQuery extends Query<Barcode> {
  constructor(protected store: BarcodeStore) {
    super(store);
  }
}
